module.exports = __webpack_public_path__ + "static/media/zoom-icon.fe30278c.svg";